<template>
  <v-card flat>
    <v-data-table
      :items="groupPurchases"
      class="elevation-1"
      hide-actions
      hide-headers
    >
      <template v-slot:items="props">
        <tr
          v-if="props.item"
          class="cursor-pointer"
          @click.stop="goToTicketOverview(props.item.pricing.id)"
        >
          <td class="pa-3" width="5%">
            <div class="subheading secondary--text">{{ props.index + 1 }}</div>
          </td>
          <td class="pa-3">
            <div>
              <h2 class="font-weight-regular primary--text">{{ props.item.pricing.name }}</h2>
              <div class="subheading secondary--text">
                <span>{{ $t("screenings.title") }} : </span>
                <span style="font-weight: bold">{{
                  props.item.pricing.screening_ids.length
                }}</span>
              </div>
              <div class="subheading secondary--text">
                {{
                  $t("screener.monetization.group_ticket.valid_till", {
                    end_date: moment
                      .utc(props.item.pricing.purchasing_end_date)
                      .local()
                      .format("lll")
                  })
                }}
              </div>
            </div>
          </td>
          <td class="pa-3">
            <div>
              <v-tooltip slot="append" top color="primary">
                <v-chip
                  slot="activator"
                  outline
                  color="secondary"
                  class="white--text cursor-pointer"
                  small
                  v-if="props.item.receipt_url"
                  @click.stop="viewReceipt(props.item.receipt_url)"
                >
                  <strong>{{ $t("screener.purchased.title") }}</strong>
                  <v-icon>mdi-download</v-icon>
                </v-chip>
                <span class="background--text body-1">
                  {{ $t("screener.purchased.plans.tooltip") }}
                </span>
              </v-tooltip>
            </div>
          </td>
          <td
            class="pa-3"
            :width="$vuetify.breakpoint.width < 1264 ? '20%' : '15%'"
          >
            <MiniCountDown
              v-if="
                checkFestivalDateIsFuture(
                  props.item.pricing.festival_start_date
                )
              "
              :screener_date="props.item.pricing.festival_start_date"
            />
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-layout row wrap justify-center text-xs-center class="pa-5">
          <v-flex xs12 class="py-2 title secondary--text">
            {{ $t("screener.consumer.no_pricing_plans") }}
          </v-flex>
          <v-flex xs12 class="py-2">
            <router-link
              class="primary--text subheading"
              :to="{ name: 'pricing.index' }"
              >{{ $t("screener.browse_pricing_plans.title") }}</router-link
            >
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { isDateFuture } from "@/helpers";
import MiniCountDown from "@/components/MiniCountDown";

export default {
  name: "PurchasedPlans",
  computed: {
    ...mapGetters("company", {
      currentCompanyId: "getCurrentCompanyId"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      groupPurchases: "getGroupPurchases"
    })
  },
  created() {
    this.getPurchasesFromApi();
  },
  components: {
    MiniCountDown
  },
  methods: {
    async getPurchasesFromApi() {
      try {
        await this.$store.dispatch("consumer/listGroupPurchases", {
          company_id: this.currentCompanyId
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    checkFestivalDateIsFuture(start_date) {
      return isDateFuture(start_date);
    },
    goToTicketOverview(pricing_id) {
      this.$router.push({
        name: "pricing.overview",
        params: {
          pricing_id: pricing_id
        }
      });
    },
    viewReceipt(receipt_url) {
      if (receipt_url) {
        window.open(receipt_url);
      }
    }
  }
};
</script>

<style></style>
